import '../assets/PagingLimit.css';const m = "op_limit_z32a7", a = "op_limitLabel_aQKjJ", i = {
  limit: m,
  limitLabel: a
};
function n(e) {
  let {
    limitLabelAttributes: l = {},
    limitInputAttributes: t = {}
  } = e;
  return t.showLimit !== void 0 && t.showLimit == !1 ? null : /* @__PURE__ */ React.createElement("label", { className: i.limitLabel, ...l }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: i.limit,
      min: "1",
      max: "99",
      type: "number",
      name: "limit",
      ...t
    }
  ), "per page");
}
export {
  n as PagingLimit
};
